import PropTypes from "prop-types";
import React from "react";
import { FormHelperText, InputBase } from "@mui/material";
import { styled } from "@mui/system";

const StyledTextarea = styled(InputBase)(({ theme, $isFaq }) => ({
  "&.Mui-error .MuiInputBase-input": {
    border: "1px solid",
    borderColor: "red",
  },
  "& .MuiInputBase-input": {
    borderRadius: "10px",
    border: "1px solid #0832DE",
    height: $isFaq ? "120px !important" : "80px !important",
    overflowY: $isFaq ? "scroll !important" : "auto",
    width: "100%",
    fontSize: 16,
    fontWeight: $isFaq ? 400 : 500,
    color: $isFaq ? "#365462 " : "#000",
    padding: "10px 12px",
  },
  width: "100%",
}));

function CustomTextArea({
  name,
  variant,
  onChange,
  value,
  placeholder,
  maxRows,
  errorMessage,
  disabled,
  minRows,
  readOnly,
  from,
  ...props
}) {
  return (
    <>
      <StyledTextarea
        variant={variant}
        id={name}
        name={name}
        maxRows={maxRows}
        minRows={minRows}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        $isFaq={from === "faq"}
        multiline
        {...props}
        readOnly={readOnly}
      />
      {errorMessage && (
        <FormHelperText sx={{ color: "error.main" }}>
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
}

export default CustomTextArea;

CustomTextArea.propTypes = {
  variant: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.func,
  errorMessage: PropTypes.string,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
};
